import { palette } from '../palette';
import { darken, lighten } from '@mui/material';
import lightOrdarkColor from "@check-light-or-dark/color";


const MuiOutlinedInput = {
  defaultProps: {
    inputProps: {
      onFocus: (event: any) => {
        event.target.value = '';
        event.target.style.fontStyle = 'normal';
        event.target.style.color = palette.info.dark;//#64759F
      },
    },
  },
  styleOverrides: {
    root: ({ theme }: any) => ({
      height: '42px',
      gap: '10px',
      fontWeight: 400,
      fontSize: '1rem',
      color: palette.info.dark,
      backgroundColor: palette.primary.contrastText,
      borderRadius: '8px',

      '& .MuiOutlinedInput-input': {
        '&.Mui-disabled': {
          'WebkitTextFillColor': 'initial',
        },
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: darken(theme.palette.background.default, 0.2),
      },

      '&:hover .MuiOutlinedInput-notchedOutline ': {
        borderColor: darken(theme.palette.background.default, 0.2)
      },


      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor:  lightOrdarkColor(theme.palette.background.default) === 'dark' ? lighten(theme.palette.background.default, 0.6) : darken(theme.palette.background.default, 0.2)
      },

      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline ': {
          borderColor: darken(theme.palette.background.default, 0.2)
        },
      },

      '&.Mui-error': {
        '&:hover .MuiOutlinedInput-notchedOutline ': {
          borderColor: palette.error.main,
        },
      },

      '&.Mui-error.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline ': {
          borderColor: palette.error.main,
        },
      },

      // '&.Mui-disabled .MuiSelect-select': {
      //   WebkitTextFillColor: palette.disabled.contrastText,//#BDC1CB
      // },
    }),
  },
};

export default MuiOutlinedInput;
